<template>
  <div class="keyword-ideas">
    <h3>Keyword Ideas</h3>
    <ul class="keyword-ideas-list">
      <li v-for="(keyword, key) in keywords" :key="key"
        :style="'opacity: ' + (1 - key * 0.1)"
        class="keyword-ideas-item">
        <button @click="() => selectKeyword(key)">
          {{keyword}}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import keywords from '@/assets/keywords'

export default {
  name: 'KeywordsIdeas',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      keywords: [],
    }
  },
  methods: {
    getKeywords() {
      this.keywords = keywords;
    },
    selectKeyword(index) {
      const keyword = this.keywords.splice(index, 1);
      this.$emit('selectKeyword', keyword[0]);
    }
  },
  mounted() {
    this.getKeywords();
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.keyword-ideas {
  color: $cloudy-blue;

  h3 {
    display: none;
  }

  .keyword-ideas-list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    font-size: 0.875em;

    .keyword-ideas-item {
      margin-right: 1em;
      margin-bottom: .5em;

      &:hover button {
        text-decoration: underline;
      }
    }
  }
}

@media (min-width: 568px) {
  .keyword-ideas {
    color: $cloudy-blue;

    h3 {
      display: block;
    }
  }
}

@media (min-width: 768px) {
  .keyword-ideas {
    color: $cloudy-blue;

    .keyword-ideas-list {
      font-size: 1em;
    }
  }
}

@media (orientation: landscape) and (max-height: 548px),
  (orientation: portrait) and (max-width: 576px) {

  .keyword-ideas {

    h3 {
      display: none;
    }
  }
}
</style>
